import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { addError } from 'actions/index';
import { searchSectionByTitle } from 'actions/search';
import { debounce } from 'helpers/content';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import Select from 'react-select/async';
import { QuillEditor } from 'UI/Inputs';
import { Checkbox, Button } from '@haldor/ui';
import api from 'lib/api';

var MentorSectionForm = /*#__PURE__*/function (_Component) {
  _inherits(MentorSectionForm, _Component);

  var _super = _createSuper(MentorSectionForm);

  function MentorSectionForm(props) {
    var _this;

    _classCallCheck(this, MentorSectionForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      var _this$props = _this.props,
          editView = _this$props.editView,
          teamsContext = _this$props.teamsContext;

      if (editView) {
        _this.loadEditView();
      }

      if (teamsContext != null) {
        _this.setSectionFieldToTeam();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "loadEditView", function () {
      var values = _this.state.values;
      values.title = _this.props.section.title;
      values.description = _this.props.section.description;
      values.HideClassroomLink = _this.props.section.hideClassroomLink;
      values.type = _this.props.section.type;

      _this.setState({
        values: values
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (input, event) {
      var values = _this.state.values;
      values[input] = event.target.value;

      _this.setState({
        values: values
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (event) {
      var values = _this.state.values;

      if (_this.props.editView == false) {
        values.title = _this.state.sectionInput.label;
        values.graphId = _this.state.sectionInput.value;
      } else {
        values.id = _this.props.section.id;
      }

      _this.setState({
        values: values
      }, function () {
        var newError = _this.validateForm();

        if (!newError) {
          var that = _assertThisInitialized(_this);

          _this.setState({
            isSending: true
          }, function () {
            if (_this.props.editView) {
              api.put('sections', values).then(function () {
                _this.props.addError(_this.props.translate('changes-saved'), 'info');

                _this.props.onAbort(true);
              });
            } else {
              api.post('sections', values).then(function (response) {
                _this.props.history.push("/groups/".concat(response.data));
              });
            }
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "validateForm", function () {
      var values = _this.state.values;
      var newError = false;

      if (values.title.length === 0) {
        newError = true;

        _this.props.addError(_this.props.translate('enter-a-title-error'), 'notice');
      }

      if (_this.props.editView == false) {
        if (values.graphId == null) {
          newError = true;

          _this.props.addError(_this.props.translate('pick-a-section'), 'notice');
        }
      }

      return newError;
    });

    _defineProperty(_assertThisInitialized(_this), "onDescriptionChange", function (text) {
      var values = _this.state.values;
      values.description = text;

      _this.setState({
        values: values
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClickSave", function (event) {
      event.preventDefault();

      if (!_this.state.isSending) {
        _this.onSubmit();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSearchSection", function (title, callback) {
      if (!title) {
        callback(null, []);
      } else {
        var searchValue = title.trim();
        searchValue = searchValue.replace(/[^A-Za-z0-9]/g, "");
        searchValue = encodeURIComponent(searchValue);

        if (searchValue != null && searchValue != "") {
          if (searchValue.length < 3) {
            callback([]);
            return false;
          }

          _this.props.searchSectionByTitle(searchValue, true, function (data) {
            var options = [];
            data.forEach(function (section) {
              options.push({
                value: section.graphId,
                label: section.title
              });
            });
            callback(options);
          });
        } else {
          callback([]);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSectionChange", function (option) {
      _this.setState({
        sectionInput: option
      });
    });

    _this.state = {
      values: {
        id: 0,
        title: '',
        description: '',
        graphId: null,
        HideClassroomLink: false,
        teamsUrl: null,
        type: 'MENTOR_GROUP'
      },
      sectionInput: null,
      isSending: false,
      disableSectionInput: false
    };
    return _this;
  }

  _createClass(MentorSectionForm, [{
    key: "setSectionFieldToTeam",
    value: function setSectionFieldToTeam() {
      var sectionInput = {
        label: this.props.teamsContext.team.displayName,
        value: this.props.teamsContext.team.groupId
      };
      this.setState({
        sectionInput: sectionInput,
        disableSectionInput: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: this.props.teamsContext != null ? 'form-container no-section-found-create-section' : 'form-container form-create-section'
      }, this.props.teamsContext != null ? /*#__PURE__*/React.createElement("div", null, this.props.translate('form-no-section-found')) : null, this.state.isSending ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }), /*#__PURE__*/React.createElement("br", null), this.props.editView ? this.props.translate('creation-phrase-1') : this.props.translate('creating-section'), "...")) : null, /*#__PURE__*/React.createElement("form", {
        className: "form form-component"
      }, this.props.editView == false ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('section')), /*#__PURE__*/React.createElement("div", {
        className: "select"
      }, /*#__PURE__*/React.createElement(Select, {
        isSearchable: true,
        isDisabled: this.state.disableSectionInput,
        isMulti: false,
        name: "section",
        value: this.state.sectionInput,
        loadOptions: debounce(this.onSearchSection, 700),
        onChange: this.onSectionChange,
        placeholder: this.props.translate('search-for-a-group'),
        className: "simple-select",
        ignoreAccents: false,
        ignoreCase: true,
        loadingMessage: function loadingMessage() {
          return _this2.props.translate('loading') + '...';
        },
        noOptionsMessage: function noOptionsMessage() {
          return _this2.props.translate('no-results');
        },
        onKeyDown: function onKeyDown(e) {
          if (e.code == 'Enter') {
            e.preventDefault();
          }
        }
      }))) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(QuillEditor, {
        placeholder: this.props.translate('describe-the-group'),
        label: this.props.translate('description'),
        onChange: this.onDescriptionChange,
        text: this.state.values.description
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null), /*#__PURE__*/React.createElement(Checkbox, {
        value: this.state.values.HideClassroomLink,
        onChange: function onChange(checked) {
          var values = _this2.state.values;
          values.HideClassroomLink = checked;

          _this2.setState({
            values: values
          });
        },
        id: "hideclassroom-checkbox",
        label: this.props.translate('hide-classroom-url')
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.onClickSave,
        type: "save"
      }, this.props.translate('publish')), /*#__PURE__*/React.createElement("div", {
        className: "align-right"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick(event) {
          event.preventDefault();

          _this2.props.onAbort(false);
        },
        type: "secondary"
      }, this.props.translate('Cancel'))))));
    }
  }]);

  return MentorSectionForm;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
};

var mapDispatchToProps = {
  searchSectionByTitle: searchSectionByTitle,
  addError: addError
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MentorSectionForm));